import { OTPConstants } from '../Constants';
import { OTPService } from '../Services';

export const OTPActions = {
    postOTP,
    postVerifyOTP
}

function postOTP(OTP, token) {
    return dispatch => {
        dispatch(request());
        OTPService.postOTP(OTP, token)
            .then(
                OTP => {
                    dispatch(success(OTP));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OTPConstants.POST_OTP_REQUEST } }
    function success(OTP) { return { type: OTPConstants.POST_OTP_SUCCESS, OTP } }
    function failure(error) { return { type: OTPConstants.POST_OTP_FAILURE, error } }
}

function postVerifyOTP(OTP, token) {
    return dispatch => {
        dispatch(request());
        OTPService.postVerifyOTP(OTP, token)
            .then(
                OTP => {
                    dispatch(success(OTP));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: OTPConstants.POST_VERIFY_OTP_REQUEST } }
    function success(OTP) { return { type: OTPConstants.POST_VERIFY_OTP_SUCCESS, OTP } }
    function failure(error) { return { type: OTPConstants.POST_VERIFY_OTP_FAILURE, error } }
}